module.exports = __webpack_public_path__ + "static/media/tablet-android.e6e5e51c.svg";